import { render } from "./Widget5.vue?vue&type=template&id=3c508e6f&ts=true"
import script from "./Widget5.vue?vue&type=script&lang=ts"
export * from "./Widget5.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__